"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var Toiletries = function Toiletries() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    // eslint-disable-next-line max-len
    d: "M4.50939 2.42077H3.54789V4.22016H6.88018V2.42077H5.91564V1.40625H7.52907C8.11796 1.40625 8.6716 1.63561 9.08804 2.05195L10.0607 3.02461L11.0551 2.03025L10.0824 1.05755C9.40037 0.375609 8.49357 0 7.52907 0H3.20251V1.40625H4.50939V2.42077Z",
    fill: "#75767A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0.331665 20.0227H6.96364V10.2394H1.41027L0.331665 20.0227Z",
    fill: "#75767A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.3243 7.0152H12.9386V8.83315H10.3243V7.0152Z",
    fill: "#75767A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.36987 15.2291H14.8933V19.9872H8.36987V15.2291Z",
    fill: "#75767A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.53809 5.6264H1.88878L1.55597 8.83317H8.86838L8.53809 5.6264Z",
    fill: "#75767A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.36987 10.2394H14.8933V13.8228H8.36987V10.2394Z",
    fill: "#75767A"
  }));
};
var _default = Toiletries;
exports.default = _default;